"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_veileder_1 = __importStar(require("nav-frontend-veileder"));
require("nav-frontend-veilederpanel-style");
const veilederPanelCls = (props) => (0, classnames_1.default)("nav-veilederpanel", {
    "nav-veilederpanel--kompakt": props.kompakt,
    "nav-veilederpanel--plakat": props.type === "plakat",
    "nav-veilederpanel--info": props.fargetema === "info",
    "nav-veilederpanel--suksess": props.fargetema === "suksess",
    "nav-veilederpanel--advarsel": props.fargetema === "advarsel",
    "nav-veilederpanel--feilmelding": props.fargetema === "feilmelding",
});
class Veilederpanel extends React.Component {
    render() {
        const { svg, children } = this.props;
        const storrelse = this.props.type === "plakat" ? "M" : "S";
        return (React.createElement("div", { className: veilederPanelCls(this.props) },
            React.createElement(nav_frontend_veileder_1.default, Object.assign({}, this.props.veilederProps, { fargetema: this.props.fargetema, storrelse: storrelse }), svg),
            React.createElement("div", { className: "nav-veilederpanel__content" }, children)));
    }
}
Veilederpanel.propTypes = {
    /**
     * Egendefinert SVG som rendres i en Veileder-boble
     */
    svg: PT.node.isRequired,
    /**
     * Predefinerte fargetemaer som bestemmer bakgrunnsfargen på veilederen og
     * border på veilederpanelet.
     */
    fargetema: PT.oneOf(["normal", "info", "suksess", "advarsel", "feilmelding"]),
    /**
     * Verdiene 'normal' og 'plakat' bestemmer henholdsvis om veilederen plasseres
     * til venstre eller over innholdet.
     */
    type: PT.oneOf(["normal", "plakat"]),
    /**
     * Kompakt versjon av veilederpanelet bruker litt mindre plass enn normalt, hvor
     * veilderen rendres overlappende med border på panelet.
     */
    kompakt: PT.bool,
    /**
     * Props som blir videreformidlet til intern instans av Veileder.
     */
    veilederProps: PT.shape(nav_frontend_veileder_1.VeilederPropsShape),
};
exports.default = Veilederpanel;
